
import { Button, ButtonProps, styled } from '@mui/material';
import CustomTooltip from 'app/components/tooltip/CustomTooltip';
interface CustomSquareButtonProps extends ButtonProps {
  isPressed?: boolean;
  squareSize?: number; // Allow specific MUI sizes or a number
  hasImage?: boolean
}

const CustomSquareButtonStyled = styled(Button)<CustomSquareButtonProps>(
  ({ theme, isPressed = false, hasImage = false, squareSize = 42 }) => ({
    minWidth: `${squareSize}px`,
    minHeight: `${squareSize}px`,
    maxWidth: isPressed ? 'auto' : `${squareSize}px`,
    maxHeight: `${squareSize}px`,
    borderRadius: theme.spacing(1),
    backgroundColor: hasImage && isPressed ? theme.palette.primary.light : isPressed ? theme.palette.primary.main : '#fff',
    color: isPressed ? '#fff' : theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.primary.light,
      boxShadow: 'none',
      border: 'none',
    },
    boxShadow: 'none',
    zIndex: 100,
    transition: 'width 0.3s ease-in-out , max-width 0.3s ease-in-out', // Add transition for both width and max-width
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
);


const CustomSquareButton: React.FC<
  ButtonProps & {
    squareSize?: number;
    isPressed?: boolean;
    hasImage?: boolean;
    placement?: 'bottom' | 'top' | 'left' | 'right';
    colorToolTip?: string,
    backgroundColorToolTip?: string

  }
> = ({ squareSize = 42, isPressed, hasImage = false, children, title, placement, colorToolTip, backgroundColorToolTip, ...props }) => {

  return (
    <CustomTooltip title={title} placement={placement ?? 'bottom'} height={`${squareSize}px`} color={colorToolTip} backgroundColor={backgroundColorToolTip} >
      <CustomSquareButtonStyled isPressed={isPressed} squareSize={squareSize} hasImage={hasImage}
        {...props}
      >
        {children}
      </CustomSquareButtonStyled>
    </CustomTooltip>
  );
};

export default CustomSquareButton;